module.exports = __webpack_public_path__ + "img/二维码_@3x.10166b71.jpg";